import { fetchExpertises } from './asyncThunk';
import { getListSlice, initialListState } from '../getListSlice';
import { IListState } from '../types';
import { IExpertise } from '../../../api/base/Expertises/types';

export type IExpertisesState = IListState<IExpertise>;

const initialState: IExpertisesState = { ...initialListState };

const expertisesSlice = getListSlice({
  moduleName: 'expertises',
  fetchDataThunk: fetchExpertises,
  initialState,
});

export const expertisesReducer = expertisesSlice.reducer;
